export default "__VITE_ASSET__CIfCDgRq__"